import { red } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  container: {
    // height: "100%",
    width: "100%",
    display: "flex-row",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: 0,
    left: 0,
    
  },
  logotypeContainer: {
    backgroundColor: theme.palette.primary.main,
    width: "100%",
    height:"20%",
    height: "full",
    display: "flex",
    flexDirection: "column",
   
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    
  },
  topImage:{
    width: "151px",
    height: "38px",
    display: "flex",
    justifyContent:"left",
    alignItems: "left",
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(4),
  },
  loginTitle:{
    display: "flex",
    color:"white",
    fontWeight: 400,
    fontSize:"36px",
    marginBottom: theme.spacing(4),
    fontFamily:'Sanchez',
    justifyContent: "center",
    alignItems: "center",
  },
  logotypeImage: {
    width: "545px",
    height: "476px",
    display: "flex",
    flexDirection: "column",
    marginBottom: theme.spacing(4),
    justifyContent: "center",
    alignItems: "center",

  },
  logotypeText: {
    color: "white",
    fontWeight: 500,
    fontSize: 84,
    [theme.breakpoints.down("md")]: {
      fontSize: 48,
    },
  },
  bottomImage:{
    width: "151px",
    height: "38px",
    display: "flex",
    justifyContent:"right",
    alignItems: "right",
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(4),
  },
  formContainer: {
    padding:"20px 0px",
    // width: "50%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      width: "90%",
    },
  },
  topBar:{
    fontWeight: 400,
    fontSize: 20,
    color:'#fff',
    fontFamily:'Poppins'
  },
  form: {
    width: 540,
    border:'#DADFEB',
    backgroundColor:'#fff',
    marginTop:theme.spacing(6),
    padding:'20px 40px',
    borderRadius:"5px",
    marginBottom:theme.spacing(4),
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  dropdownFormControl:{
    marginTop:theme.spacing(2)
  },
  selectDropdown:{
    border:'1px solid #DADFEB',
    padding:'4px 10px',
    borderRadius:'5px',
    background:'#fff',
    "&:before":{
      border:theme.palette.primary.light,
    },
    "&:after": {
      border: theme.palette.primary.main,
    },
    "&:hover:before": {
      border: `${theme.palette.primary.light} !important`,
    },

  },
  tab: {
    fontWeight: 400,
    fontSize: 18,
  },
  greeting: {
    fontSize: 16,
    fontWeight: 400,
    textAlign: "left",
    marginTop: theme.spacing(4),
    color:"#2D3748"
  },
  subGreeting: {
    fontSize: 30,
    fontFamily:'Sanchez',
    fontWeight: 400,
    textAlign: "left",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(-4),
    color:"#03997B",
    [theme.breakpoints.down("md")]: {
      fontSize: 20,
    },
  },
  googleButton: {
    marginTop: theme.spacing(6),
    boxShadow: theme.customShadows.widget,
    backgroundColor: "white",
    width: "100%",
    textTransform: "none",
  },
  googleButtonCreating: {
    marginTop: 0,
  },
  googleIcon: {
    width: 30,
    marginRight: theme.spacing(2),
  },
  creatingButtonContainer: {
    marginTop: theme.spacing(2.5),
    height: 46,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  createAccountButton: {
    height: '48px',
    width:'358px',
    textTransform: "none",
    paddingLeft:theme.spacing(6),
    paddingRight:theme.spacing(6)
  },
  formDividerContainer: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    display: "flex",
    alignItems: "center",
  },
  formDividerWord: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  formDivider: {
    flexGrow: 1,
    height: 1,
    backgroundColor: theme.palette.text.hint + "40",
  },
  errorMessage: {
    textAlign: "center",
  },
  txtHeading:{
    color:"#4A5568",
    fontSize: 16,
    fontWeight: 400,
    marginBottom: theme.spacing(-2),
    marginTop: theme.spacing(1),
  },
  textFieldline:{
    "&:before":{
      border:theme.palette.primary.light,
    },
    "&:after": {
      border: theme.palette.primary.main,
    },
    "&:hover:before": {
      border: `${theme.palette.primary.light} !important`,
    },
  },
  textFieldUnderline: {
    "&:before": {
      borderBottomColor: theme.palette.primary.light,
    },
    "&:after": {
      borderBottomColor: theme.palette.primary.main,
    },
    "&:hover:before": {
      borderBottomColor: `${theme.palette.primary.light} !important`,
    },
  },
  textField: {
    borderColor: theme.palette.background.light,
    border:theme.palette.background.light,
  },
  formButtons: {
    width: "100%",
    marginTop: theme.spacing(4),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  forgetButton: {
    textTransform: "none",
    fontWeight: 400,
  },
  loginLoader: {
    marginLeft: theme.spacing(4),
  },
  copyright: {
    marginTop: theme.spacing(6),
    whiteSpace: "nowrap",
    [theme.breakpoints.up("md")]: {
      position: "absolute",
      bottom: theme.spacing(0),
    },
  },
  Link:{
    marginTop:theme.spacing(4),
    textAlign:'center',
  },
  txtNotes:{
    fontFamily:'Poppins',
    fontSize:'11px',
    fontWeight:400
  },
  bottomLink:{
    position:'relative',
      display: '-webkit-box',
    marginTop:theme.spacing(4),
    bottom:0,
    // display:'flex',
    justifyContent: 'center',
    alignContent: 'flex-end',
    color:'#616161',
    marginBottom:theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      position:'relative',
      display: '-webkit-box',
    },
  },
  linkItem:{
    display:'flex',
    fontFamily:'Poppins',
    fontSize:'14px',
    fontWeight:400,
    color:'#616161',
    marginRight:theme.spacing(2)
  },
  iconGlobal:{
    height:'12px',
    width:'12px',
    marginTop:theme.spacing(0.5)
  }
}));
